import {
  CUSTOM_ELEMENTS_SCHEMA,
  LOCALE_ID,
  NgModule,
  isDevMode,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { OverlayModule } from '@angular/cdk/overlay';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import {
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { StoreModule } from '@ngrx/store';
import { MaterialModuleModule } from './materialModule/material-module/material-module.module';
import { CommonModule, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { NgxSliderModule } from 'ngx-slider-v2';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { InterceptorModule } from './shared/guard/interceptor/interceptor.module';
import { ExtratoComponent } from './components/extrato/extrato.component';
import { CommissionsComponent } from './components/commissions/commissions.component';
import { TransferenciaComponent } from './components/transferencia/transferencia/transferencia/transferencia.component';
import { SaqueCopiaColaComponent } from './components/transferencia/saque-copia-cola/saque-copia-cola/saque-copia-cola.component';
import { TransferBalanceComponent } from './components/transfer-balance/transfer-balance.component';
import { CryptomoedaComponent } from './components/cryptomoeda/cryptomoeda.component';
import { CryptoDepositComponent } from './components/crypto-deposit/crypto-deposit.component';
import { SubAccountsComponent } from './components/sub-accounts/sub-accounts.component';
import { TableTransactionsDirective } from './components/table-transactions/table-transactions.directive';
import { TableTransactionsReservaDirective } from './components/table-transactions-reserva/table-transactions-reserva.directive';
import { TableTransactionsCommissionsDirective } from './components/table-transactions-commissions/table-transactions-commissions.directive';
import { NgbDatePTParserFormatter } from './utils/ngbdateparse.formatter';
import { CustomDatepickerI18n, I18n } from './utils/custom.datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  NgxMaskDirective,
  NgxMaskPipe,
  provideEnvironmentNgxMask,
} from 'ngx-mask';
import {
  provideEnvironmentNgxCurrency,
  NgxCurrencyInputMode,
  NgxCurrencyDirective,
} from 'ngx-currency';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DepositComponent } from './components/deposit/deposit/deposit/deposit.component';
import { DepositPixComponent } from './components/deposit/depositPix/depositPix/depositPix.component';
import { CashInComponent } from './components/deposit/cashIn/cashIn/cashIn.component';
import { ViewAccountComponent } from './components/account/view-account/view-account.component';
import { WalletComponent } from './components/wallet/wallet.component';
import { UserConfigComponent } from './components/user-config/user-config.component';
import { AccountComponent } from './components/account/account/account.component';
import { WebhookComponent } from './components/webhook/webhook.component';
import { FormComponent } from './components/prospect/form/form.component';
import { ApproveComponent } from './components/withdraw/approve/approve.component';
import { ApproveadminComponent } from './components/withdraw/approveadmin/approveadmin.component';
import { ComponentsModule } from './components/components.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ReservaGgrComponent } from './components/reserva-ggr/reserva-ggr/reserva-ggr.component';
import { SummaryComponent } from './components/summary/summary.component';
import { TableSubAccountsDirective } from './components/table-sub-accounts/table-sub-accounts.directive';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule,  } from '@angular-material-components/datetime-picker';
import { MatIconModule } from '@angular/material/icon';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { DATETIME_GLOBAL_PROVIDERS } from './utils/datetime-format';
import { SaqueBoletoComponent } from './components/transferencia/saque-boleto/saque-boleto/saque-boleto.component';
import { ExternalCashInComponent } from './components/deposit/externalCashIn/externalCashIn.component';
import { InfractionsComponent } from './components/infractions/infractions.component';
import { ExternalCashOutComponent } from './components/transferencia/externalCashOut/externalCashOut.component';
import { CommissionsWalletComponent } from './components/commissions-wallet/commissions-wallet.component';
import { TableCommissionsWalletDirective } from './components/table-commissions-wallet/table-commissions-wallet.directive';
import { ApiCredentialsComponent } from './components/api-credentials/api-credentials.component';
import { TableApiCredentials } from './components/table-api-credentials/table-api-credentials.component';
import { TableApiCredentialsDirective } from './components/table-api-credentials/table-api-credentials.directive';
import { CheckoutConfig } from './components/checkout-config/checkout-config.component';

registerLocaleData(localePt);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    ExtratoComponent,
    SummaryComponent,
    InfractionsComponent,
    CommissionsComponent,
    CommissionsWalletComponent,
    CheckoutConfig,
    ReservaGgrComponent,
    TransferenciaComponent,
    SaqueCopiaColaComponent,
    TransferBalanceComponent,
    CryptomoedaComponent,
    CryptoDepositComponent,
    TableTransactionsDirective,
    TableTransactionsReservaDirective,
    TableTransactionsCommissionsDirective,
    TableCommissionsWalletDirective,
    TableSubAccountsDirective,
    TableApiCredentialsDirective,
    DepositComponent,
    DepositPixComponent,
    CashInComponent,
    ExternalCashInComponent,
    ExternalCashOutComponent,
    ViewAccountComponent,
    WalletComponent,
    UserConfigComponent,
    AccountComponent,
    WebhookComponent,
    FormComponent,
    ApproveComponent,
    ApproveadminComponent,
    SubAccountsComponent,
    ApiCredentialsComponent,
    SaqueBoletoComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'pt',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      isolate: false
    }),
    SharedModule,
    AppRoutingModule,
    SharedModule,
    NgbModule,
    BrowserAnimationsModule,
    OverlayModule,
    ToastrModule.forRoot({}),
    StoreModule.forRoot({}),
    MaterialModuleModule,
    NgxSliderModule,
    HttpClientModule,
    InterceptorModule,
    FormsModule,
    NgSelectModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatMomentModule,
    MatIconModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    NgxCurrencyDirective,
    ComponentsModule,
  ],
  providers: [
    [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }],
    [{ provide: NgbDateParserFormatter, useClass: NgbDatePTParserFormatter }],
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    DATETIME_GLOBAL_PROVIDERS,
    provideEnvironmentNgxMask(),
    provideEnvironmentNgxCurrency({
      align: 'left',
      allowNegative: false,
      allowZero: true,
      decimal: ',',
      precision: 2,
      prefix: 'R$ ',
      suffix: '',
      thousands: '.',
      nullable: true,
      min: null,
      max: null,
      inputMode: NgxCurrencyInputMode.Financial,
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() { }
}
